import { Instant, LocalDateTime } from "./JSJodaJSON";
import { ScheduledVisitEditRequestId, VisitBroadcastId, VisitInstanceId } from "./ObjectIds";

/**
 * The changes to a scheduled visit that a caregiver wants
 */
export type ScheduledVisitEditRequestParams =
  | ScheduledVisitEditRequestParams.Cancel
  | ScheduledVisitEditRequestParams.Reschedule;

export declare namespace ScheduledVisitEditRequestParams {
  export interface Cancel {
    type: "CANCEL";
    message: string;
  }

  export interface Reschedule {
    type: "RESCHEDULE";
    startTime: LocalDateTime;
    endTime: LocalDateTime;
    message: string;
  }
}

/**
 * The coordinators response to a rescheduling request
 */
export interface ScheduledVisitRequestResponseParams {
  message: string;
  approved: boolean;
}

/**
 * Coordinator's response(approval/rejection) to a reschedule request
 */
export interface ScheduledVisitRequestResponse {
  createdAt: Instant;
  params: ScheduledVisitRequestResponseParams;
}

/**
 * API payload from Mobile App
 */
export interface CaregiverVisitEditRequestRequest {
  params: ScheduledVisitEditRequestParams;
}

/**
 * A single rescheduling request of a caregiver that exists
 */
export interface CaregiverVisitEditRequest {
  visitId: VisitBroadcastId | null;
  patientName: string;
  patientAddress: string;
  scheduledVisitDetails: VisitEditRequestDetails;
  editRequestParams: ScheduledVisitEditParams;
}

export interface VisitEditRequestDetails {
  id: VisitInstanceId;

  /**
   * @deprecated use scheduledStartTimeLocal
   */
  scheduledStartTime: string;

  /**
   * @deprecated use scheduledEndTimeLocal
   */
  scheduledEndTime: string;

  scheduledStartTimeUTC: Instant;

  scheduledStartTimeLocal: LocalDateTime;

  scheduledEndTimeUTC: Instant;

  scheduledEndTimeLocal: LocalDateTime;

  /**
   * @deprecated delete when all clients update
   */
  isCheckedIn: boolean;
  /**
   * @deprecated delete when all clients update
   */
  isCheckedOut: boolean;

  checkInTime: Instant | null;
  checkOutTime: Instant | null;
  visitId: VisitBroadcastId | null;

  dutySheetFillPercentage: number | null;
}

/**
 * API payload from server containing all rescheduling requests for a given caregiver
 */
export interface CaregiverVisitEditRequestList {
  requests: CaregiverVisitEditRequest[];
}

/**
 * The full request that's attached to each scheduled visit
 */
export interface ScheduledVisitEditParams {
  requestId: ScheduledVisitEditRequestId;
  createdAt: Instant;
  requestParams: ScheduledVisitEditRequestParams;
  response: ScheduledVisitRequestResponse | null;
}

export const ScheduledVisitEditRequestStatus = {
  PENDING: "PENDING" as const,
  ACCEPTED: "ACCEPTED" as const,
  REJECTED: "REJECTED" as const,
};

export type ScheduledVisitEditRequestStatus = "PENDING" | "ACCEPTED" | "REJECTED";

export const ScheduledVisitEditRequestType = {
  CANCEL: "CANCEL" as const,
  RESCHEDULE: "RESCHEDULE" as const,
};

export type ScheduledVisitEditRequestType = "RESCHEDULE" | "CANCEL";

export function getScheduledVisitEditRequestStatus(
  params: ScheduledVisitRequestResponse | null
): ScheduledVisitEditRequestStatus {
  if (params === null) {
    return ScheduledVisitEditRequestStatus.PENDING;
  } else if (params.params.approved) {
    return ScheduledVisitEditRequestStatus.ACCEPTED;
  } else {
    return ScheduledVisitEditRequestStatus.REJECTED;
  }
}
